// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  SharedGalleryImage,
  SharedGalleryImagesListOptionalParams,
  SharedGalleryImagesGetOptionalParams,
  SharedGalleryImagesGetResponse,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a SharedGalleryImages. */
export interface SharedGalleryImages {
  /**
   * List shared gallery images by subscription id or tenant id.
   * @param location The name of Azure region.
   * @param galleryUniqueName The unique name of the Shared Gallery.
   * @param options The options parameters.
   */
  list(
    location: string,
    galleryUniqueName: string,
    options?: SharedGalleryImagesListOptionalParams,
  ): PagedAsyncIterableIterator<SharedGalleryImage>;
  /**
   * Get a shared gallery image by subscription id or tenant id.
   * @param location The name of Azure region.
   * @param galleryUniqueName The unique name of the Shared Gallery.
   * @param galleryImageName The name of the Shared Gallery Image Definition from which the Image
   *                         Versions are to be listed.
   * @param options The options parameters.
   */
  get(
    location: string,
    galleryUniqueName: string,
    galleryImageName: string,
    options?: SharedGalleryImagesGetOptionalParams,
  ): Promise<SharedGalleryImagesGetResponse>;
}
